// @flow
import * as React from 'react';
import {useIntl, defineMessages} from 'react-intl';
import {Caption} from 'sail/Text';
import Group from 'sail/Group';
import Icon from 'sail/Icon';
import Button from 'sail/Button';
import {next} from 'sail/Icon/Assets';

const messages = defineMessages({
  continue: {
    id: 'docsApp.success.continue',
    description: 'Button for continuing to the next worksheet',
    defaultMessage: 'Continue',
  },
});

type SuccessProps = {|
  children: React.Node,
  clickContinue: Function,
|};

export const Success = ({children, clickContinue}: SuccessProps) => {
  const intl = useIntl();

  return (
    <Group direction="vertical" spacing={8}>
      <Group direction="horizontal" spacing={8} alignItems="center">
        <Icon color="green" icon="checkCircle" />
        <Caption color="green">{children}</Caption>
      </Group>
      <Button
        color="blue"
        label={intl.formatMessage(messages.continue)}
        size="small"
        icon={next}
        iconPosition="right"
        onClick={clickContinue}
        autoFocus
      />
    </Group>
  );
};
